export default "__VITE_ASSET__9dd90f8b__"